<template>


    <section class="main-carrinho">

        <section :style="{ backgroundImage: 'url(' + $Url + fundotela + ')',backgroundColor:'#e8eaf6',backgroundSize:'cover',backgroundRepeat:'no-repeat' }">

            <div class="container">
                <div class="row py-5">
                    <div class="col-lg-6 hidden-sm-md">
                        <div class="carrinho-bg set-img">

                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="box_content">
                            <h3 class="titulo-principal text-center mb-4">Informação</h3>

                            <!-- Status -->
                            <div class="status-novaConta px-md-5">
                                <div class="status-item pos-item2">
                                    <div class="status-number"><i class="fa fa-check"></i></div>
                                    <span class="status-text">Carrinho</span>
                                </div>
                                <div class="status-item active pos-item2">
                                    <div class="status-number"><span>2</span></div>
                                    <span class="status-text">Endereço</span>
                                </div>
                                <div class="status-item">
                                    <div class="status-number"><span>3</span></div>
                                    <span class="status-text">Pedido</span>
                                </div>
                            </div>
                            <hr>
                            <!-- Form -->
                            <div class="text-center">
                                <h5 class="subtitulo mb-0">{{ Titulos[0].nome }}</h5>
                                <p class="texto-mensagem">{{ Titulos[0].referencia }}</p>
                            </div>
                 
                                <div class="form-group row">
                                    <div class="col-sm-12">
                                        <label for="inputcvc" class="col-sm-5 col-form-label label-pagto2">Nome Empresa</label>
                                        <div class="input-group">
                                            <input type="text" v-model="nome" class="input">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mt-3">
                                        <label for="inputcvc" class="col-sm-5 col-form-label label-pagto2">Telefone</label>
                                        <div class="input-group">
                                            <input type="text" v-model="telefone" v-mask="'(##) #####-####'" class="input">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mt-3">
                                        <label for="inputcvc" class="col-sm-5 col-form-label label-pagto2">Responsável</label>
                                        <div class="input-group">
                                            <input type="text" v-model="responsavel" class="input">
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                       <!--  <label for="inputcvc" class="col-sm-5 col-form-label label-pagto2">CNPJ</label>
                                        <div class="input-group">
                                            <input type="text" v-model="cnpj" v-mask="'##.###.###/####-##'" class="input">
                                        </div> -->
                                            <label style="padding-right:20px;padding-top:10px;">
                                                <input type="radio" id="cpf-example" value="###.###.###-##" pattern="\d*" v-model="dynamicMask">
                                                <span> CPF</span>
                                            </label>
                                            <label>
                                                <input type="radio" id="cnpj-example" value="##.###.###/####-##" pattern="\d*" v-model="dynamicMask">
                                                <span> CNPJ</span>
                                            </label>
                                            <br />
                                            <input type="text" inputmode="numeric"
                                                v-mask="dynamicMask"
                                                v-model="cnpj"
                                                class="input" />
                                    </div>
                                    <div class="col-sm-6">
                                        <label for="inputcvc" class="col-sm-5 col-form-label label-pagto2" style="margin-top: 13px;">E-mail</label>
                                        <div class="input-group">
                                            <input type="text" v-model="email" class="input">
                                        </div>
                                    </div>
                                    <!-- Endereço -->
                                    <div class="form-group row align-items-center mb-3 mt-3">
                                        <div class="">
                                            <label for="inputcvc" class="col-sm-5 col-form-label label-pagto2">CEP</label>
                                            <div class="input-group" style="padding-left: 15px;">
                                                <input v-model="numCep" v-mask="'#####-###'" type="text" maxlength="10" inputmode="numeric" class="input col-sm-10" @input="limpa()">
                                                <div class="input-group-append">
                                                    <a href="" @click.prevent="Buscacep(numCep)" class="input-group-text w-100 col-sm-2" id="basic-addon2" style="height: 40px;font-size: 14px;float: right;">Verificar</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="showend" class="form-group row align-items-center mb-2">
                                        <div class="col-sm-9">
                                            <label for="inputEnd" class="col-sm-5 col-form-label label-pagto2">Endereço</label>
                                            <input v-model="endereco" type="text" class="input" maxlength="400">
                                        </div>
                                        <div class="col-sm-3">
                                            <label for="inputComp" class="col-sm-5 col-form-label label-pagto2">Numero</label>
                                            <input v-model="numeroend" type="number" class="input">
                                        </div>
                                    </div>
                                    <div v-if="showend" class="form-group row align-items-center mb-2">
                                        <div class="col-sm-5">
                                            <label for="inputComp" class="col-sm-12 col-form-label label-pagto2">Complemento</label>
                                            <input v-model="complemento" type="text" class="input" maxlength="40">
                                        </div>
                                        <div class="col-sm-5">
                                            <label for="inputCidade" class="col-sm-12 col-form-label label-pagto2">Cidade</label>
                                            <input v-model="nomeCidade" type="text" class="input" maxlength="200">
                                        </div>
                                        <div class="col-sm-2">
                                            <label for="inputCidade" class="col-sm-12 col-form-label label-pagto2">Estado</label>
                                            <input v-model="siglaEstado" v-mask="'AA'" type="text" class="input" maxlength="200">
                                        </div>
                                    </div>
                                    <div v-if="showend" class="form-group row align-items-center mb-2">
                                        <div class="col-sm-12">
                                            <label for="inputBairro" class="col-sm-12 col-form-label label-pagto2">Bairro</label>
                                            <input v-model="nomeBairro" type="text" class="input" maxlength="200">
                                        </div>
                                    </div>
                                </div>
                                 <div class="col-md-10 offset-md-1 col-lg offset-lg-0 mt-4 mt-md-0 vHorarios">
                                    <label v-if="ListaEntregaFrete != ''" style="font-size:15px;font-weight:400;padding-top:10px;">Selecione tipo da Entrega<span style="color:red;">*</span></label>
                                    <div v-for="(listaFrete,index) in ListaEntregaFrete" :key="index" class="form-check">
                                        <input class="form-check-input"
                                               type="radio"
                                               :value="listaFrete"
                                               @click="ValorFrete=listaFrete.valor,calcvalorTotal()"
                                               v-model="Frete">{{ listaFrete.nome }} - R$ {{ parseFloat(listaFrete.valor).toFixed(2).toString().replace('.',',') }} Prazo: {{ listaFrete.prazo }} dias úteis
                                    </div>
                                </div>
                                <div class="voltar border-top pt-4 hidden-md hidden-lg hidden-xl">
                                    <a href="" @click="$redirect('/carrinho')" class="voltar text-secondary">Voltar</a>
                                </div>
                                <div class="pt-md-5">
                                    <div class="mt-4 mt-md-0">
                                        <button @click="carregaDados()" class="btn btn-success mt-0 px-md-5 mt-0" style="color: #fff;background-color: #5cb85c;border-color: #4cae4c;font-size: 13px;padding: 10px;">Enviar Pedido Orçamento</button>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </section>

</template>

<script>

    import moment from 'moment';
    import { cpf, cnpj } from 'cpf-cnpj-validator';
    import validator from 'validator';

    export default {
        components: {
        },
        data() {
            return {
                ProdutoId: 0,
                nome:'',
                telefone:'',
                email:'',
                responsavel:'',
                cnpj:'',
                endereco: '',
                numeroend: '',
                complemento: '',
                siglaEstado: '',
                nomeCidade: '',
                nomeBairro: '',
                numCep: '',
                Titulos: [],
                fundotela: '',
                Retornocep: {},
                showend: false,
                UltimoPedido: {},
                PedidosEndereco: [],
                PedidosCliente: [],
                ListaEntregaFrete: [],
                listaFrete: {},
                Frete: '',
                ValorFrete:0,
                ListaProdutos: [],
                listaProduto: {},
                ListaAvulsos: [],
                listaAvulso: {},
                EndNovo:false,
                valorTotal:0,
                ValorCupom:0,
                dynamicMask: '###.###.###-##',
            }
        },
        created() {
            //----------------- Titulos planos
            this.$http
                .get(this.$apiUrl + "/institucional/telas/textoinformacao")
                .then((res) => res.json())
                .then((retornoAPI) => {
                    this.Titulos = retornoAPI;

                    if (this.Titulos[0].institucionalImg != '') {
                        this.fundotela = this.Titulos[0].institucionalImg[0].urlImagem
                    }
                    else {
                        this.fundotela = '';
                    }
                });
        },
        methods: {
            currentDateTime(vdate) {
                return moment(vdate).format('LL');
            },
            limpa() {
                if (this.numCep == '') {
                    this.showend = false
                }
            },
            Buscacep(value) {
                this.$http
                    .get("https://viacep.com.br/ws/" + value + "/json/")
                    .then((res2) => res2.json())
                    .then((tiu2) => {
                        this.Retornocep = tiu2

                        if (this.Retornocep != null) {
                            this.endereco = this.Retornocep.logradouro;
                            this.numeroend = null;
                            this.complemento = null;
                            this.siglaEstado = this.Retornocep.uf;
                            this.nomeCidade = this.Retornocep.localidade;
                            this.nomeBairro = this.Retornocep.bairro;
                            this.showend = true;

                            this.CalculaFrete();
                        }
                        else {
                            alert("CEP inexistente");
                        }
                    });
            },
            carregaDados() {
                if (this.nome == '') {
                    this.$mensagem_normal("Preencha o campo nome");
                } else if (this.telefone == '') {
                    this.$mensagem_normal("Preencha o telefone");
                } else if (this.responsavel == '') {
                    this.$mensagem_normal("Preencha seu nome no responsável");
                } else if (this.cnpj == '') {
                    this.$mensagem_normal("Preencha o CPF ou CNPJ");
                } else if (this.dynamicMask == '###.###.###-##' && !cpf.isValid(this.cnpj) ){
                    this.$mensagem_normal("CPF inválido");
                } else if (this.dynamicMask == '##.###.###/####-##' && !cnpj.isValid(this.cnpj) ){
                    this.$mensagem_normal("CNPJ inválido");
                } else if (this.email == '') {
                    this.$mensagem_normal("Preencha o e-mail");
                } else if (!validator.isEmail(this.email)) {
                    this.$mensagem_normal("E-mail inválido.");
                } else if (this.numCep == '') {
                    this.$mensagem_normal("Preencha o CEP da empresa e clique em verificar.");
                } else if (this.endereco == '') {
                    this.$mensagem_normal("Preencha o endereço");
                } else if (this.numeroend == null) {
                    this.$mensagem_normal("Preencha o número do endereço");
                } else if (this.complemento == '') {
                    this.$mensagem_normal("Preencha o complemento do endereço");
                } else if (this.nomeCidade == '') {
                    this.$mensagem_normal("Preencha a cidade do endereço");
                } else if (this.siglaEstado == '') {
                    this.$mensagem_normal("Preencha a sigla do estado do endereço");
                } else if (this.nomeBairro == '') {
                    this.$mensagem_normal("Preencha o bairro do endereço");
                }
                else {
                    let dadosArmazenados = localStorage.getItem(this.$UsuarioDados);
                        if (dadosArmazenados) {
                            dadosArmazenados = JSON.parse(dadosArmazenados);
                            if (dadosArmazenados.agenda[0] != null) {
                                dadosArmazenados.agenda[0] = {
                                    nome: this.nome,
                                    telefone:this.telefone,
                                    email:this.email,
                                    responsavel: this.responsavel,
                                    cnpj: this.cnpj,
                                    estado: this.siglaEstado,
                                    cidade: this.nomeCidade,
                                    bairro: this.nomeBairro,
                                    endereco: this.endereco,
                                    numero: this.numeroend,
                                    complemento: this.complemento,
                                    cep: this.numCep,
                                };
                            }
                            else {
                                dadosArmazenados.agenda.push({
                                    nome: this.nome,
                                    telefone:this.telefone,
                                    email:this.email,
                                    responsavel: this.responsavel,
                                    cnpj: this.cnpj,
                                    estado: this.siglaEstado,
                                    cidade: this.nomeCidade,
                                    bairro: this.nomeBairro,
                                    endereco: this.endereco,
                                    numero: this.numeroend,
                                    complemento: this.complemento,
                                    cep: this.numCep,
                                });
                            }
                        }
                    localStorage.setItem(this.$UsuarioDados, JSON.stringify(dadosArmazenados))
                    this.$redirect("/pedidoRealizado");
                }
            },
             calcvalorTotal() {
                let dadosArmazenados = localStorage.getItem(this.$UsuarioDados);
                if (!dadosArmazenados) {
                    return 0;
                }
                else {
                    dadosArmazenados = JSON.parse(dadosArmazenados);
                    let vproduto = 0;
                     if (dadosArmazenados.cupom != '') {
                       this.ValorCupom = dadosArmazenados.cupom[0].ValorCupom;
                     }
                    if (dadosArmazenados.produtos != '') {
                        vproduto = dadosArmazenados.produtos.reduce((sum, item) => sum + (item.produto.valorAte * parseInt(item.qtde, 10)), 0);
                    }

                    let vavulso = 0
                    if (dadosArmazenados.avulsos != '') {
                       if (dadosArmazenados.avulsos[0].produtoAvulsoId != 0) {
                           vavulso = dadosArmazenados.avulsos.reduce((sum, item) => sum + item.avulso.valorDe, 0);
                       }
                    }

                    this.valorTotal = (vproduto + vavulso) - this.ValorCupom;
                }
            },
            CalculaFrete() {
                if (this.numCep == '') {
                    this.$mensagem_normal("Por favor preencha o CEP de entrega");
                }
                else {
                    this.ListaEntregaFrete = [];
                    let dadosArmazenados = localStorage.getItem(this.$UsuarioDados);
                    if (dadosArmazenados) {
                        dadosArmazenados = JSON.parse(dadosArmazenados);
                        this.ListaProdutos = dadosArmazenados.produtos;
                            if (dadosArmazenados.avulsos != '') {
                            if (dadosArmazenados.avulsos[0].produtoAvulsoId != 0) {
                                this.ListaAvulsos = dadosArmazenados.avulsos;
                            }
                            }
                    }
                    this.ValorFrete = '';
                    this.$http
                        .get(this.$apiUrl + "/entregacorreio")
                        .then((res2) => res2.json())
                        .then((tiu2) => {
                            this.CepOrigem = tiu2[0].cep;

                            let InformacaoFrete = {
                                Produtos: [],
                                ProdutosAvulsos: [],
                                CepOrigem: this.CepOrigem,
                                CepDestino: this.numCep,
                                Correios: true,
                                Entregas: true
                            }

                            //console.log(this.ListaProdutos)
                            this.ListaProdutos.forEach((itemp) => {
                                itemp.produto.qtdeMinima = parseInt(itemp.qtde,10);
                                //console.log(itemp.produto)
                                InformacaoFrete.Produtos.push(itemp.produto);
                            });

                            this.ListaAvulsos.forEach((itempa) => {
                                InformacaoFrete.ProdutosAvulsos.push(itempa.itemAvulso);
                            });

                            //console.log(InformacaoFrete)

                            this.$http
                                .post(this.$apiUrl + "/EntregaFrete/Calcular", InformacaoFrete)
                                .then(response => {

                                    this.ListaEntregaFrete = response.body
                                    //console.log("aqui");
                                     //console.log(this.ListaEntregaFrete)
                                    /*  let vrecebe = []
                                    this.ListaEntregaFrete.forEach((itemex) => {
                                       if (itemex.nome.indexOf("Frete") != -1 || itemex.nome.indexOf("Miguel") != -1){
                                           vrecebe.push(itemex);
                                       }
                                    });

                                    if (vrecebe!= ''){ 
                                        this.ListaEntregaFrete = vrecebe;
                                    } */
                                     let vrecebe = []
                                    this.ListaEntregaFrete.forEach((itemex) => {
                                         //aqui valida compra minima
                                      /*  if (itemex.compraMinima > 0){
                                           this.MostraCompraminia = "Nas Compras acima de R$ " + parseFloat(itemex.compraMinima).toFixed(2).toString().replace('.',',') + ", Você ganha frete Grátis!";
                                       } */
                                        console.log(this.valorTotal)
                                       if (this.valorTotal > itemex.compraMinima){
                                           vrecebe.push(itemex);
                                       }
                                    });

                                    if (vrecebe!= ''){ 
                                        let _filtraGratis = vrecebe;
                                        let vrecebe2 = []
                                         _filtraGratis.forEach((itemex2) => {
                                             if (itemex2.nome.indexOf("Frete") != -1 || itemex2.nome.indexOf("Miguel") != -1){
                                              vrecebe2.push(itemex2);
                                             }
                                         });
                                       
                                        if (vrecebe2 != ''){
                                            this.ListaEntregaFrete = vrecebe2;
                                            //this.MostraCompraminia = "";
                                        }
                                        else{
                                           this.ListaEntregaFrete = _filtraGratis;
                                        }
                                    }
                                },
                                    error => {
                                        this.$mensagem_erro("CEP inválido.")
                                        console.log(error)
                                    });

                        });
                }

            },
        }
    }

</script>

<style scoped>

    @import '/css_cart/carrinho.css';
    @import '/css_cart/nova_conta.css';
</style>